import React from 'react';
import { ICommerceApiSettings, IGridSettings, IImageData, IImageSettings } from '@msdyn365-commerce/core-internal';
import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import { Image } from '@msdyn365-commerce/core';
import { Modal, ModalBody } from '@msdyn365-commerce-modules/utilities';
import { isArrayDeepEmpty } from '../../../../themes/dobbies/utilities/is-array-deep-empty';
enum MediaType {
    Image = 'Image',
    Video = 'Video'
}

export interface IProductMedia {
    MediaType: MediaType;
    ImageName: string;
    VideoUrl: string;
    VideoThumbnail: string;
}

interface IProductDetailMediaProps {
    media: IProductMedia[];
    apiSettings: ICommerceApiSettings;
    gridSettings?: IGridSettings;
}

export function ProductDetailMedia({ media, apiSettings, gridSettings }: IProductDetailMediaProps) {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [activeMedia, setActiveMedia] = React.useState<IProductMedia | null>(null);

    const toggleModal = () => setIsModalOpen(prev => !prev);

    const onMediaClick = (item: IProductMedia) => {
        setActiveMedia(item);
        setIsModalOpen(true);
    };

    const imageSettings: IImageSettings = React.useMemo(
        () => ({
            viewports: {
                xs: { q: 'w=773&h=1080', w: 773, h: 1080 },
                lg: { q: 'w=773&h=1080', w: 773, h: 1080 },
                xl: { q: 'w=773&h=1080', w: 773, h: 1080 }
            },
            lazyload: true
        }),
        []
    );

    const imageProps = React.useMemo(
        () => ({
            gridSettings: gridSettings!,
            imageSettings
        }),
        [gridSettings, imageSettings]
    );

    const getImageUrl = (fileName?: string) => generateImageUrl(fileName, apiSettings)?.replace('fileName=/', 'fileName=');

    const getImageData = (src?: string, altText?: string): IImageData => ({
        src,
        altText
    });

    return (
        <div className={`product-detail-media ${isArrayDeepEmpty(media) ? 'd-none' : ''}`}>
            {media &&
                media.length > 0 &&
                media.map((item, index) => {
                    const isImage = item.MediaType === MediaType.Image;
                    const src = isImage ? getImageUrl(item.ImageName) : getImageUrl(item.VideoThumbnail);

                    if (!src) {
                        return null;
                    }

                    return (
                        <div
                            key={`${item.MediaType}-${index}`}
                            onClick={() => onMediaClick(item)}
                            className={isImage ? undefined : 'video-thumbnail'}
                        >
                            <Image
                                {...getImageData(src, item.ImageName)}
                                {...imageProps}
                                loadFailureBehavior={isImage ? 'hide' : 'empty'}
                            />
                        </div>
                    );
                })}

            <Modal isOpen={isModalOpen} className='product-detail-modal' toggle={toggleModal}>
                <ModalBody>
                    <span
                        className='product-detail-modal--close'
                        onClick={() => {
                            setIsModalOpen(false);
                        }}
                    ></span>{' '}
                    {activeMedia?.MediaType === MediaType.Video && (
                        <video width='100%' height='100%' controls preload='metadata'>
                            <source src={activeMedia.VideoUrl} type='video/mp4' />
                        </video>
                    )}
                    {activeMedia?.MediaType === MediaType.Image && (
                        <Image {...getImageData(getImageUrl(activeMedia.ImageName))} {...imageProps} loadFailureBehavior='hide' />
                    )}
                </ModalBody>
            </Modal>
        </div>
    );
}
